import styled from 'styled-components';
import Partner from '../components/Partner';
function Partners() {
  return (
    <Wrap>
      <Title>TEAM</Title>
      <PartnerList>
        <Partner name="shin"></Partner>
        <Partner name="yu"></Partner>
        <Partner name="lee"></Partner>
      </PartnerList>
    </Wrap>
  );
}

const PartnerList = styled.ul`
  justify-content: space-around;
  width: 80%;
  margin: 20px auto;
  display: flex;
  @media only screen and (max-width: 992px) {
    flex-wrap: wrap;
    width: 100%;
  }
`;
const Title = styled.div`
  color: ${props => props.theme.mainColor};
  font-size: 25px;
  position: relative;
  display: inline-block;
  margin-bottom: 25px;
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: linear-gradient(to right, #fff, #f1bf78, #a07b53);
  }
`;
const Wrap = styled.div`
  text-align: center;
  padding: 80px;
  @media only screen and (max-width: 992px) {
    padding: 40px;
  }
`;

export default Partners;
